import React from 'react';
import { ContentPlayer } from './ContentPlayer';
import { VideoComponent } from './VideoComponent';

interface VideoProps {
    media: Inspire.Video;
    onVideoMuteChange?: (mute: boolean) => void;
    onVideoEnd?: VoidFunction;
    onVideoStart?: VoidFunction;
    onVideoPlay?: VoidFunction;
    onVideoPause?: VoidFunction;
    soundContainer?: HTMLDivElement | null;
}

export const Video = (props: VideoProps) => {
    const {
        media,
        onVideoMuteChange,
        onVideoEnd,
        onVideoStart,
        onVideoPlay,
        onVideoPause,
        soundContainer,
    } = props;

    return media.streams?.length ? (
        <ContentPlayer
            {...media}
            onToggleMuteUnmute={onVideoMuteChange}
            onVideoEnd={onVideoEnd}
            onVideoStart={onVideoStart}
            onVideoPlay={onVideoPlay}
            onVideoPause={onVideoPause}
            soundContainer={soundContainer}
        />
    ) : (
        <VideoComponent
            src={media.url}
            firstFrameUrl={media.firstFrameUrl}
            soundContainer={soundContainer}
        />
    );
};
